import React from 'react';

/**
 * The map iframe is rendered persistently in the SideBar component
 * (with-new-report-sidebar.tsx) to avoid reloading on navigation.
 * This screen component is a no-op placeholder for the route.
 */
function MapScreen() {
  return null;
}

export default MapScreen;
